import { graphql } from "@/graphql";

export const updateBusinessUnitUserMutation = graphql(`
  mutation UpdateBusinessUnitUser($input: UpdateBusinessUnitUserInput!) {
    updateBusinessUnitUser(input: $input) {
      businessUnitUser {
        id
        status
        role {
          id
          name
        }
      }
      errors {
        field
        message
      }
    }
  }
`);
